// Module
var code = `<div data-bind="css: model.rootCss ">
    <!-- ko component: { name: 'svc-search', params: { model: model.searchManager } } -->
    <!-- /ko -->
    <!-- ko component: { name: 'svc-scroll' } -->
    <!-- ko template: { name: 'survey-content', data: model.survey  } -->
    <!-- /ko -->
    <!-- /ko -->
</div>`;
// Exports
export default code;